/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiWorkSpaceLayoutViewConfig} from "./UiWorkSpaceLayoutViewConfig";
import {UiWorkSpaceLayoutItemConfig} from "./UiWorkSpaceLayoutItemConfig";
import {UiToolbarConfig} from "./UiToolbarConfig";
import {UiRelativeWorkSpaceViewPosition} from "./UiRelativeWorkSpaceViewPosition";
import {UiSplitSizePolicy} from "./UiSplitSizePolicy";


export interface UiWorkSpaceLayoutConfig extends UiComponentConfig {
	_type?: string;
	views: UiWorkSpaceLayoutViewConfig[];
	initialLayout: UiWorkSpaceLayoutItemConfig;
	childWindowPageTitle: string;
	toolbar?: UiToolbarConfig;
	newWindowBackgroundImage?: string;
	newWindowBlurredBackgroundImage?: string
}

export interface UiWorkSpaceLayoutCommandHandler {
	setToolbar(toolbar: UiToolbarConfig): void;
	addViewAsTab(newView: UiWorkSpaceLayoutViewConfig, existingViewName: string, select: boolean): void;
	addViewRelativeToOtherView(newView: UiWorkSpaceLayoutViewConfig, existingViewName: string, relativePosition: UiRelativeWorkSpaceViewPosition, sizePolicy: UiSplitSizePolicy, referenceChildSize: number): void;
	addViewToTopLevel(newView: UiWorkSpaceLayoutViewConfig, windowId: string, relativePosition: UiRelativeWorkSpaceViewPosition, sizePolicy: UiSplitSizePolicy, referenceChildSize: number): void;
	moveViewToTab(viewName: string, existingViewName: string, select: boolean): void;
	moveViewRelativeToOtherView(viewName: string, existingViewName: string, relativePosition: UiRelativeWorkSpaceViewPosition, sizePolicy: UiSplitSizePolicy, referenceChildSize: number): void;
	moveViewToTopLevel(viewName: string, windowId: string, relativePosition: UiRelativeWorkSpaceViewPosition, sizePolicy: UiSplitSizePolicy, referenceChildSize: number): void;
	redefineLayout(windowId: string, newLayout: UiWorkSpaceLayoutItemConfig): void;
	removeView(viewName: string): void;
	refreshView(viewName: string, component: UiComponentConfig, tabIcon: string, tabCaption: string, tabCloseable: boolean): void;
	refreshViewComponent(viewName: string, component: UiComponentConfig): void;
	selectViewTab(viewName: string): void;
}

export interface UiWorkSpaceLayoutEventSource {
	onLayoutChanged: TeamAppsEvent<UiWorkSpaceLayout_LayoutChangedEvent>;
	onViewDraggedToNewWindow: TeamAppsEvent<UiWorkSpaceLayout_ViewDraggedToNewWindowEvent>;
	onViewNeedsRefresh: TeamAppsEvent<UiWorkSpaceLayout_ViewNeedsRefreshEvent>;
	onChildWindowCreationFailed: TeamAppsEvent<UiWorkSpaceLayout_ChildWindowCreationFailedEvent>;
	onChildWindowClosed: TeamAppsEvent<UiWorkSpaceLayout_ChildWindowClosedEvent>;
	onViewTabSelected: TeamAppsEvent<UiWorkSpaceLayout_ViewTabSelectedEvent>;
	onViewTabClosed: TeamAppsEvent<UiWorkSpaceLayout_ViewTabClosedEvent>;
	onViewsMinimized: TeamAppsEvent<UiWorkSpaceLayout_ViewsMinimizedEvent>;
	onViewsRestored: TeamAppsEvent<UiWorkSpaceLayout_ViewsRestoredEvent>;
	onViewsMaximized: TeamAppsEvent<UiWorkSpaceLayout_ViewsMaximizedEvent>;
}

export interface UiWorkSpaceLayout_LayoutChangedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.layoutChanged";
	redundancyKey?: string;
	layoutsByWindowId: {[name: string]: UiWorkSpaceLayoutItemConfig}
}

export interface UiWorkSpaceLayout_ViewDraggedToNewWindowEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewDraggedToNewWindow";
	redundancyKey?: string;
	windowId: string;
	viewName: string
}

export interface UiWorkSpaceLayout_ViewNeedsRefreshEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewNeedsRefresh";
	redundancyKey?: string;
	viewName: string
}

export interface UiWorkSpaceLayout_ChildWindowCreationFailedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.childWindowCreationFailed";
	redundancyKey?: string;
	viewName: string
}

export interface UiWorkSpaceLayout_ChildWindowClosedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.childWindowClosed";
	redundancyKey?: string;
	windowId: string;
	viewsInWindow: string[]
}

export interface UiWorkSpaceLayout_ViewTabSelectedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewTabSelected";
	redundancyKey?: string;
	viewName: string;
	siblingViewNames: string[]
}

export interface UiWorkSpaceLayout_ViewTabClosedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewTabClosed";
	redundancyKey?: string;
	viewName: string
}

export interface UiWorkSpaceLayout_ViewsMinimizedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewsMinimized";
	redundancyKey?: string;
	viewNames: string[]
}

export interface UiWorkSpaceLayout_ViewsRestoredEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewsRestored";
	redundancyKey?: string;
	viewNames: string[]
}

export interface UiWorkSpaceLayout_ViewsMaximizedEvent extends UiEvent {
	_type: "UiWorkSpaceLayout.viewsMaximized";
	redundancyKey?: string;
	viewNames: string[]
}

